import { AvailabilityEncoder } from '@susu/headless-commerce/features/configurator/domain/Availability/AvailabilityEncoder'
import { Product } from '@susu/headless-commerce/features/configurator/domain/Product/Product'
import type { ProductDataAccessObject } from '@susu/headless-commerce/features/configurator/domain/Product/ProductDataAccessObject'

export class ProductEncoder {
  static encode(instance: Product): ProductDataAccessObject {
    return {
      availability: AvailabilityEncoder.encode(instance.availability.value),
      badge: instance.badge.value,
      categoryId: instance.categoryId.value,
      categoryName: instance.categoryName.value,
      code: instance.code.value,
      colorId: instance.colorId.value,
      currency: instance.currency.value,
      desktopImage: instance.desktopImage.value,
      enabledInLookBuilder: instance.enabledInLookBuilder.value,
      fabricCodeID: instance.fabricCodeID.value,
      fitId: instance.fitId.value,
      id: instance.id.value,
      isCustomMadeProduct: instance.isCustomMadeProduct.value,
      isEnabledCustomizeButton: instance.isEnabledCustomizeButton.value,
      isFabricAvailable: instance.isFabricAvailable.value,
      materialValue: instance.materialValue.value,
      mobileImage: instance.mobileImage.value,
      name: instance.name.value,
      nameInEnglish: instance.nameInEnglish.value,
      onlineMaterial: instance.onlineMaterial.value,
      price: instance.price.value,
      size: instance.size.value,
      sizeId: instance.sizeId.value,
      style: instance.style.value,
      styleId: instance.styleId.value,
      type: instance.type.value,
      url: instance.url.value,
    }
  }

  static decode(properties: ProductDataAccessObject) {
    const instance = new Product(
      AvailabilityEncoder.decode(properties.availability),
      properties.badge,
      properties.categoryId,
      properties.categoryName,
      properties.code,
      properties.colorId,
      properties.currency,
      properties.desktopImage,
      properties.enabledInLookBuilder,
      properties.fabricCodeID,
      properties.fitId,
      properties.id,
      properties.isCustomMadeProduct,
      properties.isEnabledCustomizeButton,
      properties.isFabricAvailable,
      properties.materialValue,
      properties.mobileImage,
      properties.name,
      properties.nameInEnglish,
      properties.onlineMaterial,
      properties.price,
      properties.size,
      properties.sizeId,
      properties.style,
      properties.styleId,
      properties.type,
      properties.url,
    )

    return instance
  }
}
